import { API } from "aws-amplify";

export async function fetchAllMonitors(rangeSetting: number) {
  const body: any = {
    email: localStorage.getItem("username"),
    rangeSetting,
  }
  try {
    const res: any = await API.post("data", "/data/all", {
      body,
    });
    return res;
  } catch(e) {
    console.log(e)
  }
}





// WEBPACK FOOTER //
// ./src/utils/api/fetchAllMonitors.ts